import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EstatusJSON } from "../../models/EstatusJSON";
import { environment } from '../../../../../environments/environment';
import { AvailabilityDTO } from '../../../locations-map/models/AvailabilityDTO';
import { IApiBase } from './Interface/IApiBase.interface';
import { CatalogPaginationRequest } from '../../models/CatalogPagination/CatalogPaginationRequest';
import { FilterRequest } from '../../models/Filter/FilterRequest';
@Injectable({
    providedIn: 'root'
  })

export class AvailabilityAPIService implements IApiBase{
  private configUrl: string;

  constructor(
    private http: HttpClient){
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error('Method not implemented.');
  }
  update(datos: any) {
    throw new Error('Method not implemented.');
  }
  delete(id: any) {
    throw new Error('Method not implemented.');
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error('Method not implemented.');
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }

  InsertRange(availabilityList: AvailabilityDTO[]):any{
    console.log("/api/Availability/InsertRange/");
    return this.http.post<EstatusJSON>( this.configUrl + "/api/Availability/InsertRange", availabilityList);
  }

  GetListAvailabilityFilterByLocationCategory(filtersRequest : any[], initialDate: string, finalDate: string, idLocationCategories: number[]): any {
    const avalabilityFiltersRequest = { idLocationCategories: idLocationCategories, initialDate: initialDate, finalDate: finalDate, filtersRequest: filtersRequest };
    console.log("/api/Location/GetListAvailabilityFilterByLocationCategory");
     return this.http.post<any>(this.configUrl + "/api/Location/GetListAvailabilityFilterByLocationCategory", avalabilityFiltersRequest)
  }
}
